import { Injectable, inject } from '@angular/core';
import { GridViewModel, SearchViewModel } from '@models/module/grid';
import { HttpService } from '@shared/services';
import { SOVCategory, SOVCategoryGroup, SOVCategoryGroupRow } from './category-group.model';

@Injectable({ providedIn: 'root' })
export class CategoryGroupService {
  http = inject(HttpService);

  search(searchView: SearchViewModel) {
    return this.http.post<GridViewModel<SOVCategoryGroupRow[]>>('_api/SOVCategoryGroup/Search', searchView, {
      useLoader: false,
    });
  }

  create(categoryGroup: SOVCategoryGroup) {
    return this.http.post<number>('_api/SOVCategoryGroup/Create', categoryGroup);
  }

  update(categoryGroup: SOVCategoryGroup) {
    return this.http.put<void>('_api/SOVCategoryGroup/Update', categoryGroup);
  }

  delete(id: number) {
    const params = this.http.buildHttpParams({ id });
    return this.http.put<void>('_api/SOVCategoryGroup/Delete', null, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  toggleDisable(id: number) {
    const params = this.http.buildHttpParams({ id });
    return this.http.put<void>('_api/SOVCategoryGroup/ToggleDisable', null, {
      useLoader: false,
      httpOptions: { params },
    });
  }

  getOtherCategories(categoryGroupId: number) {
    const params = this.http.buildHttpParams({ categoryGroupId });
    return this.http.get<SOVCategory[]>('_api/SOVCategoryGroup/GetOtherCategories', {
      useLoader: false,
      httpOptions: { params },
    });
  }
}
